import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import toNumber from 'lodash/toNumber'
import { Box, Text } from '@machobear/design-system'
import { getPaymentFrequency, formatListingPrice } from '@/utils/listings'
import { useListingData } from '../context/listing-data'

const Separator = styled.div`
  height: 4px;
  font-size: 22px;
  line-height: 4px;
`

export const ListingInfo = () => {
  const { t } = useTranslation()
  const { unitType, bedrooms, bathrooms, groupListing, price, priceFrequency, groupMinimumPrice } =
    useListingData()

  const bedroomsText =
    bedrooms === 0
      ? t('common.studio')
      : t('b.listing.view.count_bedrooms.text', {
          count: bedrooms,
          defaultValue: '{{count}} Bed',
          defaultValue_plural: '{{count}} Beds'
        })

  return (
    <Box display="flex" flexDirection="row" gap="xxsmall" alignItems="center">
      {groupListing && <Text>{t('b.listings.view.starting_at.text', 'Starting at')}</Text>}
      <Text size="standard">
        {formatListingPrice(groupListing ? groupMinimumPrice : price)} /{' '}
        {getPaymentFrequency(priceFrequency)?.toLowerCase()}
      </Text>
      <Separator>&#183;</Separator>
      <Text size="standard">
        {unitType === 'single'
          ? t('b.listing.view.private_room.text', 'Private room')
          : bedroomsText}
      </Text>
      {unitType === 'entire' && (
        <>
          <Separator>&#183;</Separator>
          <Text size="standard">
            {t('b.listing.view.count_bathrooms.text', {
              count: toNumber(bathrooms),
              defaultValue: '{{count}} Bath',
              defaultValue_plural: '{{count}} Baths'
            })}
          </Text>
        </>
      )}
    </Box>
  )
}
